import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button } from "reactstrap";
import { responseToaster } from "../../../helperFunctions";
import { updateMaxLoginUsers } from "../../../redux/slices/usersSlice";
import InputField from "../../../components/Custom/Forms/InputField/InputField";
import Loader from "../../../components/Custom/Loader";

const MaxLoginUser = (props) => {
  const { item, onGet } = props;

  const dispatch = useDispatch();

  const [isInput, setIsInput] = useState(false);
  const [value, setValue] = useState("");
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState("");

  const onUpdate = async () => {
    if (!value || isNaN(value) || Number(value) <= 0) {
      setError("Please enter a valid number.");
      return;
    }

    try {
      setIsLoading(true);
      setError("");
      const payload = {
        id: item?.id,
        max_login_user: value
      };
      const res = await dispatch(updateMaxLoginUsers(payload)).unwrap();
      responseToaster(res);
      onGet();
    } catch (err) {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        className={"cell-order"}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="order-singal-div">
          {isInput ? (
            <div className="gap-1">
              <InputField
                autoFocus
                value={value}
                placeholder="Max allowed login users"
                type="number"
                onChange={(e) => {
                  setValue(e.target.value)
                  if (error) setError("");
                }
                }
                err={error ? "Please enter a valid number." : ""}
              />
              <div className="d-flex gap-1 justify-content-end" style={{ marginTop: "10px" }}>
                <Button color="primary" onClick={onUpdate}>
                  {isLoading ? <Loader /> : <i className="fa-solid fa-check"></i>}
                </Button>
                <Button
                  color="danger"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIsInput(false);
                    setError("");
                  }}
                >
                  <i className="fa-solid fa-xmark"></i>
                </Button>
              </div>
            </div>
          ) : (
            <span
              className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setIsInput(true);
                setValue(item?.max_login_user);
              }}
            >
              <div className="order-singal-div">
                <div style={{ color: "var(--chatlook-darkblue--)" }}>{item?.max_login_user || "Not Set"}</div>
              </div>
            </span>
          )}
        </div>
      </div>
    </>
  );
};

export default MaxLoginUser;
